import { render, staticRenderFns } from "./Planos.vue?vue&type=template&id=1b79287a&scoped=true"
import script from "./Planos.vue?vue&type=script&lang=js"
export * from "./Planos.vue?vue&type=script&lang=js"
import style0 from "./Planos.vue?vue&type=style&index=0&id=1b79287a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b79287a",
  null
  
)

export default component.exports